'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactHelmet = require('react-helmet');

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var OnlineApp = function (_Component) {
  (0, _inherits3.default)(OnlineApp, _Component);

  function OnlineApp() {
    (0, _classCallCheck3.default)(this, OnlineApp);
    return (0, _possibleConstructorReturn3.default)(this, (OnlineApp.__proto__ || (0, _getPrototypeOf2.default)(OnlineApp)).apply(this, arguments));
  }

  (0, _createClass3.default)(OnlineApp, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'div',
          { className: 'container' },
          _react2.default.createElement(_reactHelmet2.default, { title: 'On-line aplikace' }),
          _react2.default.createElement(
            'div',
            { className: 'col-md-12' },
            _react2.default.createElement(
              'h1',
              null,
              'On-line aplikace'
            ),
            _react2.default.createElement(
              'p',
              null,
              'V na\u0161\xED on-line aplikaci vid\xEDte, co va\u0161e d\xEDt\u011B d\u011Bl\xE1. N\xE1pl\u0148 tr\xE9nink\u016F, v\xFDkonnostn\xED posun a tipy na cvi\u010Den\xED. P\u0159\xEDstup do aplikace z\xEDsk\xE1te p\u0159ed odjezdem na t\xE1bor nebo p\u0159ed prvn\xEDm tr\xE9ninkem v p\u0159\xEDpravce. Informace aktualizujeme v re\xE1ln\xE9m \u010Dase.'
            )
          )
        )
      );
    }
  }]);
  return OnlineApp;
}(_react.Component);

exports.default = OnlineApp;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/OnlineApp/OnlineApp.js
// module id = 1110
// module chunks = 0